var styles = {
  "PlainAction": "Online-Store-UI-PlainAction_3ie91",
  "hyperlink": "Online-Store-UI-PlainAction--hyperlink_1d1s5",
  "subtitle": "Online-Store-UI-PlainAction--subtitle_1to1w",
  "looseLineHeight": "Online-Store-UI-PlainAction--looseLineHeight_q18hs",
  "extraLooseLineHeight": "Online-Store-UI-PlainAction--extraLooseLineHeight_1k7qh",
  "fontSizeBodyMd": "Online-Store-UI-PlainAction--fontSizeBodyMd_1rwtt",
  "small": "Online-Store-UI-PlainAction--small_8dbb4",
  "fontSizeBodyLg": "Online-Store-UI-PlainAction--fontSizeBodyLg_bufye",
  "fontSizeBodyXl": "Online-Store-UI-PlainAction--fontSizeBodyXl_1iv6t",
  "noPadding": "Online-Store-UI-PlainAction--noPadding_1k4ih",
  "hasContent": "Online-Store-UI-PlainAction--hasContent_136z0",
  "slim": "Online-Store-UI-PlainAction--slim_1fwzk",
  "iconOnly": "Online-Store-UI-PlainAction--iconOnly_gjha2",
  "disclosure": "Online-Store-UI-PlainAction--disclosure_vds8y",
  "extraPadding": "Online-Store-UI-PlainAction--extraPadding_1jnm7",
  "paddingLoose": "Online-Store-UI-PlainAction--paddingLoose_5o751",
  "backgroundSubdued": "Online-Store-UI-PlainAction--backgroundSubdued_1jjuq",
  "withSurfaceSubduedBackground": "Online-Store-UI-PlainAction--withSurfaceSubduedBackground_yzskk",
  "backgroundDark": "Online-Store-UI-PlainAction--backgroundDark_w0sdc",
  "backgroundGrey": "Online-Store-UI-PlainAction--backgroundGrey_1640u",
  "interactive": "Online-Store-UI-PlainAction--interactive_19zan",
  "disabled": "Online-Store-UI-PlainAction--disabled_8f6d0",
  "pressed": "Online-Store-UI-PlainAction--pressed_1a4ql",
  "destructive": "Online-Store-UI-PlainAction--destructive_1maw7",
  "darkInverse": "Online-Store-UI-PlainAction--darkInverse_q20qk",
  "dark": "Online-Store-UI-PlainAction--dark_1fx1e",
  "Subtitle": "Online-Store-UI-PlainAction__Subtitle_1to1w",
  "unstyled": "Online-Store-UI-PlainAction--unstyled_8xu3p",
  "alignLeft": "Online-Store-UI-PlainAction--alignLeft_163iy",
  "fullWidth": "Online-Store-UI-PlainAction--fullWidth_1ejbt",
  "loading": "Online-Store-UI-PlainAction--loading_yq4qy",
  "outline": "Online-Store-UI-PlainAction--outline_17ln1",
  "vertical": "Online-Store-UI-PlainAction--vertical_1e7ln",
  "Interior": "Online-Store-UI-PlainAction__Interior_13egi",
  "Prefix": "Online-Store-UI-PlainAction__Prefix_4xc91",
  "WrappedContent": "Online-Store-UI-PlainAction__WrappedContent_1ur63",
  "Disclosure": "Online-Store-UI-PlainAction__Disclosure_vds8x",
  "SubtitleWrapperContent": "Online-Store-UI-PlainAction__SubtitleWrapperContent_1nqdv",
  "ExternalIcon": "Online-Store-UI-PlainAction__ExternalIcon_4rgj2",
  "PrefixItem": "Online-Store-UI-PlainAction__PrefixItem_zjezq",
  "truncate": "Online-Store-UI-PlainAction--truncate_1wsmy",
  "multilineTruncate": "Online-Store-UI-PlainAction--multilineTruncate_2b1gt",
  "Content": "Online-Store-UI-PlainAction__Content_qjaty",
  "removeUnderline": "Online-Store-UI-PlainAction--removeUnderline_1xuy1",
  "IconWrapper": "Online-Store-UI-PlainAction__IconWrapper_1dtgx",
  "LoadingIndicator": "Online-Store-UI-PlainAction__LoadingIndicator_y6qg8",
  "toneMagic": "Online-Store-UI-PlainAction--toneMagic_p7ecd"
};

export { styles as default };
